import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

export const StyledTypography = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

StyledTypography.displayName = 'StyledTypography';
